export function loadImagePromise(url: string): Promise<HTMLImageElement> {
    return new Promise<HTMLImageElement>((resolve, error) => {
        const msg = `Could not load image: "${url}"`;
        if (url) {
            const image = new Image();
            image.onload = () => {
                resolve(image);
            };
            image.onerror = () => {
                error(msg);
            };
            image.src = url;
        }
        else {
            error(msg);
        }
    });
}

export class PromiseResolver<T = void> {
    resolve: (value?: T | PromiseLike<T> | undefined) => void;
    reject: any;
    promise: Promise<T>;

    constructor() {
        this.promise = new Promise<T>((res, rej) => {
            this.resolve = res;
            this.reject = rej;
        });
    }
}

export function requestAnimationFramePromise(): Promise<number> {
    return new Promise<number>((resolve) => {
        requestAnimationFrame((time: number) => {
            resolve(time);
        });
    });
}

export function sleep(duration: number = 0): Promise<void> {
    return new Promise((resolve) => {
        setTimeout(resolve, duration);
    });
}


/**
 * Skip a number of animation frames.
 * 1 means that you skip the first and resolves on the second frame
 * @param frameToSkip
 */
export async function skipAnimationFrames(frameToSkip: number = 1): Promise<void> {
    for (let i = 0; i < frameToSkip + 1; i++) {
        await requestAnimationFramePromise();
    }
}

// Run two callbacks in two sequential animation frames to guarantee that they are executed
// export function requestAnimationSequence (callback1, callback2) {

//     let r1, r2;

//     const clear = () => {
//         if (r1) {
//             window.cancelAnimationFrame(r1);
//         }
//         if (r2) {
//             window.cancelAnimationFrame(r2);
//         }
//     }

//     r1 = window.requestAnimationFrame(() => {
//         if (callback1) {
//             callback1();
//         }
//         if (callback2) {
//             r2 = window.requestAnimationFrame(() => {
//                 clear();
//                 callback2();
//             });
//         }
//     });

//     return clear;
// }
